module.exports = __webpack_public_path__ + "static/media/card-payment.d9275e66.svg";